import React from 'react';
import DetailedTable from '../../components/DetailedTable';
import columns from './columns';

interface ServiceParticipantProps {
  data: serviceInfo;
}

type serviceInfo = {
  [key: string]: any;
};

const ServiceParticipant = (props: ServiceParticipantProps) => {
  return (
    <DetailedTable
      id="ServiceParticipant"
      title=""
      columns={columns}
      data={props.data.serviceInfo || []}
      showSelection={false}
      showPagination={true}
      page={0}
      rowsPerPage={10}
      tableActions={[]}
    />
  );
};

export default ServiceParticipant;
